const config = {
  // apiUrl: "http://localhost/SYMAC TFE/symac_tfe_be/public/",
  // storageUrl: "http://localhost/SYMAC TFE/symac_tfe_be/storage/",

  apiUrl: "https://be.symac-tfe.my.id/public/",
  storageUrl: "https://be.symac-tfe.my.id/storage/",
};

export default config;
